import { render, staticRenderFns } from "./uploadFile.vue?vue&type=template&id=0b535666&scoped=true"
import script from "./uploadFile.vue?vue&type=script&lang=js"
export * from "./uploadFile.vue?vue&type=script&lang=js"
import style0 from "./uploadFile.vue?vue&type=style&index=0&id=0b535666&prod&scoped=true&lang=scss"
import style1 from "./uploadFile.vue?vue&type=style&index=1&id=0b535666&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b535666",
  null
  
)

export default component.exports